/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { memo, useRef } from 'react';
import useElementDimensions from 'src/hooks/useElementDimension';
import useSeekbar from 'src/components/SeekBar/hooks/useSeekbar';
import classNames from 'classnames';
import TimeTooltip from '../TimeTooltip';
import styles from './styles.module.scss';

export interface ISeekbarProps {
  currentPercent: number;
  bufferIndicatorPercent: number;
  onSeeking: (percentValue: number) => void;
  onSeekEnded?: () => void;
  onSeekInit?: () => void;
}

const SeekBar = ({ currentPercent, bufferIndicatorPercent, onSeeking, onSeekInit, onSeekEnded }: ISeekbarProps) => {
  const seekBarRef = useRef<HTMLDivElement>(null);

  const seekbarDimensions = useElementDimensions(seekBarRef);

  const { startSeeking, positionPercent, updateTimeTargetPreview, targetTime, timePreviewPosition, seeking } =
    useSeekbar({
      currentPercent,
      onSeeking,
      onSeekInit,
      onSeekEnded,
      seekbarDimensions,
    });

  return (
    <div
      ref={seekBarRef}
      className={styles.seekbarContainer}
      tabIndex={seeking ? undefined : 0}
      data-testid='seekbar'
      role='progressbar'
      onTouchStart={startSeeking}
      onMouseDown={startSeeking}
      onMouseMove={updateTimeTargetPreview}
    >
      {<TimeTooltip offsetLeft={timePreviewPosition} time={targetTime} />}
      <div className={styles.seekbar}>
        <div data-testid='seekbar-buffer' className={styles.buffer} style={{ width: `${bufferIndicatorPercent}%` }} />
        <div data-testid='seekbar-fill' className={styles.fill} style={{ width: `${positionPercent}%` }} />
        <div data-testid='seekbar-handle' className={classNames(styles.handle, { [styles.seeking]: seeking })} />
      </div>
    </div>
  );
};

export default memo(SeekBar);
